export default "__VITE_ASSET__D2F$U3Dx__"